import { render } from "./AnnouncementBoxContent.vue?vue&type=template&id=1a3fb65c"
import script from "./AnnouncementBoxContent.vue?vue&type=script&lang=js"
export * from "./AnnouncementBoxContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__